/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { Product } from '../types/products';
import { fetchProducts } from './api';

export const getProducts = async (): Promise<Product[]> => {
    return await fetchProducts();
};